import React from 'react';

export type AdOfTheWeekFooterProps = {
    backgroundColor?: string;
    logo?: string;
    logoBackgroundColor?: string;
};

export function AdOfTheWeekFooter(props: AdOfTheWeekFooterProps) {
    const { backgroundColor, logo, logoBackgroundColor } = props;

    const footerStyle: React.CSSProperties = React.useMemo(() => {
        const borderColor =
            backgroundColor === '#ffffff' ||
            typeof logoBackgroundColor === 'undefined'
                ? '#C3CCD9'
                : backgroundColor;

        const borderStyle =
            logoBackgroundColor === '#ffffff' ||
            typeof logoBackgroundColor === 'undefined'
                ? `1px solid ${borderColor}`
                : 'none';

        return {
            backgroundColor: logoBackgroundColor,
            borderTop: borderStyle,
        };
    }, [backgroundColor, logoBackgroundColor]);

    if (!logo) {
        return null;
    }

    return (
        <div
            className="flex rounded-b-8 justify-end h-[46] sm:h-[68]"
            style={footerStyle}
        >
            <img
                alt=""
                src={logo}
                className="self-center object-contain mr-16 h-28 w-[74] sm:h-[36] sm:w-96"
            />
        </div>
    );
}
